import { useEffect } from "react";
import "./App.css";
import Mainpage from "./Components/Mainpage/Index";
import Home from "./Components/Home/Index";
import { Provider } from "react-redux";
import { store } from "./helpers/store";

// import EnterPan from "./pay-later/pages/EnterPan";
import EnterPan from "./pay-later/pages/EnterPan";
import ValidatingPan from "./pay-later/pages/ValidatingPan";
import Sanctions from "./pay-later/pages/Sanction";
import Address from "./pay-later/pages/Address";
import Approval from "./pay-later/pages/Approval";
import WorkDetails from "./pay-later/pages/WorkDetails";
import CourseDetails from "./pay-later/pages/CourseDetails";
import Congratulations from "./pay-later/pages/Congratulations";
import SelectDate from "./pay-later/pages/SelectDate";
import SanctionLetter from "./pay-later/pages/SanctionLetter";
import SelectEmi from "./pay-later/pages/SelectEmi";
import Selfie from "./pay-later/pages/Sanction/selfie";
import Digilocker from "./pay-later/pages/Sanction/digilocker";
import Mandate from "./pay-later/pages/Sanction/mandate";
import Agreement from "./pay-later/pages/Sanction/agreement";
import Loandetails from "./Components/Mainpage/Loandetails";
import ApplicationDetails from "./Components/Mainpage/ApplicationsDetails";
import Repaymentdetails from "./Components/Mainpage/Repaymentdetails";
import Noactiveloans from "./Components/Mainpage/Noactiveloans";
import Noactiverepayments from "./Components/Mainpage/Noactiverepayments";
import FeeManagement from "./feeManagement";
import UpFrontFee from "./upFrontFee";
import PayFees from "./payFees";
import Medvarsity from "./partners/medvarsity"
import Vishwani from "./partners/viswani"
import Terms from "./Terms";
import Consent from "./Consent";
import Privacy from "./Privacy";
import Main from "./main";
import AOS from "aos";
import Bstmt from "./bstmt";
import NoDues from "./no-dues"
import MandateInProgress from "./mandate-active";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { DataProvider } from "./pay-later/context/DataContext";
import AccountAggregator from "./pay-later/pages/AccountAgregator";
import NetBanking from "./pay-later/pages/AccountAgregator/pdfBankStatement";
import BankStatement from "./pay-later/pages/AccountAgregator/pdfBankStatement";
import Emihistory from "./Components/Mainpage/Emihistory";
import AdminLogin from "./Components/Home/AdminLogin";
import AccountAggregatorSuccess from "./pay-later/pages/AccountAgregator/success";
import ParkingPage from "./pay-later/pages/ParkingPage";
import DisbursedPage from "./pay-later/pages/Disbursed";
import PFCollection from "./pay-later/pages/PFCollection";
import RejectedPage from "./pay-later/pages/Rejected";
import ParkingPageRejected from "./pay-later/pages/ParkingPage/rejected";

import BankStatementUploadPage from "./pay-later/pages/BankStatementUpload";
import BankDetailsInfoPage from "./pay-later/pages/BankDetailsInfo";
import Fpc from "./fpc"
import Conditions from "./Conditions";
import Interest from "./interest"
import BankStatementEvaluation from "./pay-later/pages/BankStatementEvaluate";
import ShriRam from './partners/shriRamUniversal';
import Tsra from "./partners/shriRamAcademy";
import Icon from "./partners/icon"
import NotFound from "./NotFound";
import ISB from "./partners/isb";
import IVI from "./partners/ivi";
import PSIB from "./partners/psib";
import THUB from "./partners/thub";
import ACC from "./partners/acc";
import UGPG from "./partners/ug-pg";
import RVIT from "./partners/rvit";
import DATAGAMI from "./partners/datagami";
import MEDICAL from "./partners/medical";
import Experian from "./Experian";
import CIRCUIT from "./partners/circuit";
import { initMixpanel} from "./mixpanel";
import OnboardingForm from "./Components/OnboardForm/OnboardingForm";
import EligibilityPanDetails from "./pay-later/pages/EligibilityFlow/PanDetails";
import EligibilityPanUpload from "./pay-later/pages/EligibilityFlow/PanUpload";
import EligibilityVerifyOtp from "./pay-later/pages/EligibilityFlow/VerifyOtp";
import EligibilityAddressDetails from "./pay-later/pages/EligibilityFlow/AddressDetails";
import EligibilityIncomeDetails from "./pay-later/pages/EligibilityFlow/IncomeDetails";
import EligibilityBankStatementOptions from "./pay-later/pages/EligibilityFlow/BankStatementOptions";
import EligibilityCourseDetails from "./pay-later/pages/EligibilityFlow/CourseDetails";
import EligibilityLogin from "./pay-later/pages/EligibilityFlow/Login";
import EligibilitySanctionDetails from "./pay-later/pages/EligibilityFlow/SanctionDetails";
import EligibilitySanctionLetter from "./pay-later/pages/EligibilityFlow/SanctionLetter";
import EligibilitySanctions from "./pay-later/pages/EligibilityFlow/Sanctions";
import EligibilityDigilocker from "./pay-later/pages/EligibilityFlow/Digilocker";
import EligibilitySelfie from "./pay-later/pages/EligibilityFlow/Selfie";
import EligibilityAgreement from "./pay-later/pages/EligibilityFlow/Agreement";
import EligibilityEmandate from "./pay-later/pages/EligibilityFlow/Emandate";
import EligibilityApplicationSuccess from "./pay-later/pages/EligibilityFlow/ApplicationSuccess";
import EligibilityUnderReview from "./pay-later/pages/EligibilityFlow/UnderReview";
import EligibilityRejected from "./pay-later/pages/EligibilityFlow/Rejected";
import EligibilityCongratulations from "./pay-later/pages/EligibilityFlow/Congratulations";
import EligibilityCollectEmail from "./pay-later/pages/EligibilityFlow/CollectEmail";
import EligibilityEmiDate from "./pay-later/pages/EligibilityFlow/EmiDate";
import EligibilityEvaluating from "./pay-later/pages/EligibilityFlow/Evaluating";
import EligibilityWaiting from "./pay-later/pages/EligibilityFlow/EligibilityWaiting";
import Dashboard from "./Components/Mainpage/Dashboard";
function App() {
  AOS.init();

  useEffect(() => {
    initMixpanel()
  }, [])
  
  return (
    <>
      <Provider store={store}>
        <DataProvider>
          <Router>
            <Routes>
            <Route path="*" element={<NotFound />} />
              <Route exact path="/login" element={<Navigate to="/eligibility/login" replace />} />
               <Route exact path="/signup" element={<OnboardingForm />} />
              <Route exact path="/login/admin" element={<AdminLogin />} />
              <Route exact path="/mainpage" element={<Mainpage />} />
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route path="/eligibility/verify/:data" element={<EligibilityVerifyOtp />} />
              <Route path="/eligibility/address" element={<EligibilityAddressDetails />} />
              <Route path="/eligibility/income" element={<EligibilityIncomeDetails />} />
              <Route path="/eligibility/login" element={<EligibilityLogin />} />
              <Route path="/eligibility/course-details" element={<EligibilityCourseDetails />} />
              <Route path="/eligibility/bank-statement" element={<EligibilityBankStatementOptions />} />
              <Route path="/eligibility/sanction-details" element={<EligibilitySanctionDetails />} />
                <Route path="/eligibility/sanction-letter" element={<EligibilitySanctionLetter />} />
              <Route path="/eligibility/digilocker" element={<EligibilityDigilocker />} />
              <Route path="/eligibility/selfie" element={<EligibilitySelfie />} />
              <Route path="/eligibility/agreement" element={<EligibilityAgreement />} />
              <Route path="/eligibility/emandate" element={<EligibilityEmandate />} />
              <Route path="/eligibility/sanctions" element={<EligibilitySanctions />} />
              <Route path="/eligibility/success" element={<EligibilityApplicationSuccess />} />
              <Route path="/eligibility/under-review" element={<EligibilityUnderReview />} />
              <Route path="/eligibility/rejected" element={<EligibilityRejected />} />
              <Route path="/eligibility/congratulations" element={<EligibilityCongratulations />} />
              <Route path="/eligibility/email" element={<EligibilityCollectEmail />} />
              <Route path="/eligibility/emi-date" element={<EligibilityEmiDate />} />
              <Route path="/eligibility/evaluating" element={<EligibilityEvaluating />} />
              <Route path="/eligibility/waiting" element={<EligibilityWaiting />} />
              <Route path="/eligibility/pan" element={<EligibilityPanDetails />} />
              <Route path="/eligibility/pan-upload" element={<EligibilityPanUpload />} />
              <Route path="/eligibility/:data" element={<EligibilityPanDetails />} />
              <Route path="/:data" element={<EnterPan />} />
              <Route path="/validating" element={<ValidatingPan />} />
              <Route path="/sanctions" element={<Sanctions />} />  {/*stage 4, 9,10,11, 12,13 */}
              <Route path="/sanctions/digilocker" element={<Digilocker />} />
              <Route path="/sanctions/selfie" element={<Selfie />} />
              <Route path="/sanctions/agreement" element={<Agreement />} />
              <Route path="/sanctions/mandate" element={<Mandate />} />
              {/*<Route path="/address" element={<Address />} /> */} {/* stage 1 */}
              <Route path="/approval" element={<Approval />} />
              {/*<Route path="/work-details" element={<WorkDetails />} /> */} {/* stage  2*/}
              <Route path="/course-details" element={<CourseDetails />} />
              <Route path="/congratulations" element={<Congratulations />} />
              <Route path="/parking-page" element={<ParkingPage />} /> {/* stage 4*,5,6,7*/}
              <Route path="/parking-page-rejected" element={<ParkingPageRejected />}/>
              <Route path="/select-emi" element={<SelectEmi />} />  {/* stage 3,8 */}
              <Route path="/select-date" element={<SelectDate />} />
              <Route path="/sanction-letter" element={<SanctionLetter />} />
              <Route path="/disbursed-page" element={<DisbursedPage />} />  {/* stage 5, 14 ,16*/}
              <Route path="/pf-collection" element={<PFCollection />} /> {/* stage 15*/}
              <Route path="/rejected-page" element={<RejectedPage />} /> {/* stage 18 */}
              <Route path="/aa-success" element={<AccountAggregatorSuccess />} />
              <Route exact path="/mainpage/loandetails"  element={<Loandetails />}/>
              <Route exact path="/mainpage/loandetails/emihistory" element={<Emihistory />} />
              <Route exact path="/mainpage/applicationDetails"  element={<ApplicationDetails />}/>
              <Route exact path="/mainpage/receipts"  element={<Repaymentdetails />} />
              <Route exact path="/mainpage/noactiveloans"  element={<Noactiveloans />} />
              <Route exact path="/mainpage/noactiverepayments"  element={<Noactiverepayments />} />
              <Route path="/" element={<Main />} />
              <Route path="/feeManagement" element={<FeeManagement />} />
              <Route path="/bstmt" element={<Bstmt />} />
              <Route path="/no-emi-dues" element={<NoDues/>} />
              <Route path='/mandate-active' element={<MandateInProgress/>} />
              <Route path="/account-aggregator"  element={<AccountAggregator />} />
              <Route path="/account-aggregator/bank-statement"  element={<BankStatement />} />

              {/* <Route path="/payments" element= {<MyPayments/>} /> */}
              <Route path="/upfrontFees" element={<UpFrontFee />} />
              <Route path="/payFees" element={<PayFees />} />
              <Route path="/medvarsity" element={<Medvarsity/>} />
              <Route path="/vishwani" element={<Vishwani/>} />
              <Route path="/tsus" element={<ShriRam/>} />
              <Route path="/tsra" element={<Tsra/>} />
              <Route path="/ips" element={<Icon/>} />
              <Route path="/psib" element={<PSIB/>} />
              <Route path="/isb" element={<ISB/>} />
              <Route path="/ivi" element={<IVI/>} />
              <Route path="/t-hub" element={<THUB/>} />
              <Route path="/agi" element={<ACC/>} />
              <Route path="/ug-pg" element={<UGPG/>} />
              <Route path="/medical" element={<MEDICAL/>} />
              <Route path="/rvit" element={<RVIT/>} />
              <Route path="/datagami" element={<DATAGAMI/>} />
              <Route path="/apply/terms" element={<Terms />} />
              <Route path="/consent" element={<Consent />} />
              <Route path="/experian" element={<Experian />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms-conditions" element={<Conditions />} />
              <Route path="/fpc" element={<Fpc />} />
              <Route path="/interest" element={<Interest />} />
              <Route path="/bankstatement-upload" element={<BankStatementUploadPage />} />
              <Route path="/lead-circuits" element={<CIRCUIT/>} />
              <Route path = "/bankdetails-info"  element ={<BankDetailsInfoPage />} />

              <Route path = "/bankstatement-evaluation" element = {<BankStatementEvaluation/>} />

              

              
              
            </Routes>
          </Router>
        </DataProvider>
      </Provider>
    </>
  );
}

export default App;
